import { ContactFormStandard } from './ContactFormStandard';

export type { TypeContactFormStandardProps } from './types';
export default ContactFormStandard;
